import { useEffect, useState, useCallback } from 'react';
import { Alert, Box, Button, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { apiGlobal } from '../services/api';
import { useUserSession } from '../contexts/UserSessionContext.jsx';

const PendingInvitesBanner = () => {
  const session = useUserSession();
  const navigate = useNavigate();
  const [invites, setInvites] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await apiGlobal.get('/users/me/invites');
      setInvites(res?.invites || []);
    } catch (err) {
      console.warn('PendingInvitesBanner: load failed', err);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (!session.loading && session.user) load();
  }, [session.loading, session.user, load]);

  useEffect(() => {
    const onChange = () => load();
    window.addEventListener('budgetrecon:invites-changed', onChange);
    return () => window.removeEventListener('budgetrecon:invites-changed', onChange);
  }, [load]);

  if (!loaded || invites.length === 0) return null;

  const first = invites[0];
  const rest = invites.length - 1;

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Alert severity="info" variant="filled">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
          <Typography sx={{ flex: 1 }}>
            You have {invites.length} pending invite{invites.length === 1 ? '' : 's'}.
            {first.groupName ? ` Latest: "${first.groupName}" as ${first.role}.` : ''}
            {rest > 0 ? ` +${rest} more.` : ''}
          </Typography>
          <Button
            color="inherit"
            variant="outlined"
            onClick={() => navigate(`/invitations/${encodeURIComponent(first.inviteId)}`)}
          >
            Review
          </Button>
        </Stack>
      </Alert>
    </Box>
  );
};

export default PendingInvitesBanner;
